<!-- SwipeItem.vue -->
<template>
  <div class="swipe-item" :class="customClass" :style="customStyle">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SwipeItem',
  props: {
    // Custom class for the item
    customClass: {
      type: String,
      default: '',
    },
    // Custom styles for the item
    customStyle: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss" scoped>
.swipe-item {
  flex-shrink: 0;
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}
</style>
